import { Component, inject, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { LayoutComponent, LayoutService } from "@iatec/nephos-layout";
import { take } from "rxjs";

import { AzureAdService } from "@core/services/azure-ad.service";
import { IProfile } from "../../../Domain/Models/user.model";
import { LogoComponent } from "../components/logo/logo.component";
import { ProfileSidebarComponent } from "../components/profile-sidebar/profile-sidebar.component";
import { TopbarComponent } from "../components/topbar/topbar.component";

@Component({
    selector: "app-main-template",
    imports: [LogoComponent, TopbarComponent, ProfileSidebarComponent, LayoutComponent],
    templateUrl: "./main-template.component.html",
    styleUrl: "./main-template.component.scss"
})
export class MainTemplateComponent implements OnInit {
    imageToShow: any;
    profile?: IProfile;
    isImageLoading: boolean = false;

    private _layoutService = inject(LayoutService);
    private azureAdService = inject(AzureAdService);
    private domSanitizer = inject(DomSanitizer);

    ngOnInit(): void {
        this._layoutService.layoutConfig.update((config) => ({
            ...config,
            preset: "Aura",
            primary: "emerald",
            surface: "gray",
            options: {
                darkModeSelector: ".app-dark"
            },
            menuMode: "reveal"
        }));

        if (!this.azureAdService.isCurrentRoutePublic()) {
            this.getProfile();
            this.getProfilePicture();
        }
    }

    getProfile() {
        return this.azureAdService
            .getUserProfile()
            .pipe(take(1))
            .subscribe((profileInfo) => {
                this.profile = profileInfo;
            });
    }

    getProfilePicture() {
        return this.azureAdService
            .getImage()
            .pipe(take(1))
            .subscribe({
                next: (blob) => {
                    let urlCreator = window.URL || window.webkitURL;
                    this.imageToShow = this.domSanitizer.bypassSecurityTrustUrl(urlCreator.createObjectURL(blob));

                    if (this.imageToShow) {
                        if (this.profile) {
                            this._layoutService.profile.set({
                                name: this.profile.displayName || "",
                                urlAvatar: this.imageToShow.changingThisBreaksApplicationSecurity
                            });
                        } else {
                            this._layoutService.profile.set({
                                urlAvatar: this.imageToShow.changingThisBreaksApplicationSecurity
                            });
                        }
                    }
                    this.isImageLoading = true;
                },
                error: (error) => {
                    this.isImageLoading = false;
                }
            });
    }
}
